import React from 'react';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { translateBlockValue } from 'i18n';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { Box } from '@mui/material';
import {
    StyFilters,
    StyHomeFiltersWrapper,
} from './StyledComponentBudgetFilters';
import BudgetAutocomplete from 'routes/BudgetModule/components/shared/BudgetAutocomplete/BudgetAutocomplete';
import { ALL_BUDGETS_VALUE } from 'routes/BudgetModule/components/BudgetOverview/constants';

type Props = {
    selectedBudgetName: string | null;
    setSelectedBudgetName: (arg1: string) => void;
    sortedBudgetNames: string[];
    selectedExercice: number | null;
    setSelectedExercice: (arg1: string) => void;
    exercicesByBudgetName: { [key: string]: number[] };
};

export default function BudgetOverviewFilters({
    selectedBudgetName,
    setSelectedBudgetName,
    sortedBudgetNames,
    selectedExercice,
    setSelectedExercice,
    exercicesByBudgetName,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const location = useLocation();

    const trackFilterChange = (filter: string) => {
        trackEventBudget(TRACKABLE_EVENTS.budget.ux.homeFiltersChanged, {
            filter,
        });
    };

    const handleBudgetNameSelect = (newValue: string): void => {
        setSelectedBudgetName(newValue);
        trackFilterChange(translateBlockValue('budget.name'));
    };

    const handleExerciceSelect = (newValue: number): void => {
        setSelectedExercice(newValue.toString());
        trackFilterChange(translateBlockValue('budgetLine.year'));
    };
    const hideBudgetFilter = location.pathname.includes(
        '/budget_overview/all_aps/',
    );

    const sortedBudgetExercices =
        selectedBudgetName && exercicesByBudgetName[selectedBudgetName]
            ? [...exercicesByBudgetName[selectedBudgetName]].sort(
                  (a, b) => b - a,
              )
            : [];

    return (
        <Box sx={{ width: '100%' }}>
            <StyHomeFiltersWrapper>
                <Typography variant="h5">
                    {t('budgetOverview.selectFilter')}
                </Typography>
            </StyHomeFiltersWrapper>
            <StyHomeFiltersWrapper>
                <StyFilters>
                    {!hideBudgetFilter && (
                        <BudgetAutocomplete
                            disableClearable
                            value={selectedBudgetName}
                            onChange={handleBudgetNameSelect}
                            options={sortedBudgetNames}
                            getOptionLabel={(option) =>
                                option === ALL_BUDGETS_VALUE
                                    ? t(
                                          'budgetOverview.allBudgets',
                                      ).toUpperCase()
                                    : option
                            }
                            inputWidth="15rem"
                        />
                    )}
                    <BudgetAutocomplete
                        disableClearable
                        value={selectedExercice}
                        onChange={handleExerciceSelect}
                        options={sortedBudgetExercices}
                    />
                </StyFilters>
            </StyHomeFiltersWrapper>
        </Box>
    );
}
